// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PrimaryKeyRequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import {SpeciesRequestSource} from './SpeciesRequestSource';
import {SpeciesRequestStatus} from './SpeciesRequestStatus';
import {ContextNodeDetails} from './ContextNodeDetails';
import {SpeciesRequestSpeciesList} from './SpeciesRequestSpeciesList';

const _associations = [
			{
				name: 'SpeciesRequestSource',
				model: new SpeciesRequestSource(),
				type: 'ParentPointer',
				using: 'speciesRequestSourceId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'SpeciesRequestSource',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'SpeciesRequestStatus',
				model: new SpeciesRequestStatus(),
				type: 'ParentPointer',
				using: 'speciesRequestStatusId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'SpeciesRequestStatus',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'ObservedProjectContextNode',
				model: new ContextNodeDetails(),
				type: 'ParentPointer',
				using: 'observedProjectContextNodeId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: true,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'ObservedProjectContextNode',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'SpeciesRequestSpeciesList',
				model: new SpeciesRequestSpeciesList(),
				type: 'ArrayOfChildren',
				using: 'speciesId',
				isHidden: true,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'SpeciesRequestSpeciesList',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'speciesId',
				placeholder: null,
				key: 'speciesId',
				isPrimaryKey: true,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.speciesId,
				setter: (x, y) => x.speciesId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new PrimaryKeyRequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Project where the species was observed',
				placeholder: null,
				key: 'observedProjectContextNodeId',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 9,
				getter: (x) => x.observedProjectContextNodeId,
				setter: (x, y) => x.observedProjectContextNodeId = y,
				defaultValue: null,
				editor: 'ContextNodeFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
					contextNodeTypeId: "3",
				}
			},
			{
				title: 'Date species was observed',
				placeholder: null,
				key: 'observedDate',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 10,
				getter: (x) => x.observedDate,
				setter: (x, y) => x.observedDate = y,
				defaultValue: null,
				editor: 'DateTimeFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Requester Notes',
				placeholder: 'Common local name also includes coyote willow. Identification verified by using The Jepson Manual.',
				key: 'requesterNotes',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 12,
				getter: (x) => x.requesterNotes,
				setter: (x, y) => x.requesterNotes = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(65535),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Requested On',
				placeholder: null,
				key: 'requested',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: true,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.requested,
				setter: (x, y) => x.requested = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Requested By',
				placeholder: null,
				key: 'requestedByUserId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.requestedByUserId,
				setter: (x, y) => x.requestedByUserId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: [
					{
						"component": 'UserFieldViewer',
						"fieldKey": 'requestedByUserId',
					},
					{
						"value": ' at ',
					},
					{
						"component": 'DateFieldViewer',
						"fieldKey": 'requested',
					},
				],
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Requested From',
				placeholder: null,
				key: 'speciesRequestSourceId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: true,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.speciesRequestSourceId,
				setter: (x, y) => x.speciesRequestSourceId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'SpeciesRequestSourceFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'speciesRequestStatusId',
				placeholder: null,
				key: 'speciesRequestStatusId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.speciesRequestStatusId,
				setter: (x, y) => x.speciesRequestStatusId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'SpeciesRequestStatusFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Reviewer Notes (i.e. Denial Reason)',
				placeholder: 'Required for denial. The requester will see these notes.',
				key: 'reviewerNotes',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: 'Required for denial. The requester will see these notes.',
				requiresPermission: ["can_alter_global_species_list"],
				group: '',
				groupTitle: null,
				displayOrder: 13,
				getter: (x) => x.reviewerNotes,
				setter: (x, y) => x.reviewerNotes = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(65535),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Reviewed On',
				placeholder: null,
				key: 'reviewed',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: true,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.reviewed,
				setter: (x, y) => x.reviewed = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Reviewed By',
				placeholder: null,
				key: 'reviewedByUserId',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: true,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.reviewedByUserId,
				setter: (x, y) => x.reviewedByUserId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: [
					{
						"component": 'UserFieldViewer',
						"fieldKey": 'reviewedByUserId',
					},
					{
						"value": ' on ',
					},
					{
						"component": 'DateFieldViewer',
						"fieldKey": 'reviewed',
					},
				],
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Species Lists where it is applicable',
				placeholder: null,
				key: '_speciesListIds',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: '',
				displayOrder: 11,
				getter: (x) => x._speciesListIds,
				setter: (x, y) => x._speciesListIds = y,
				defaultValue: null,
				editor: 'SpeciesListCheckboxFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class SpeciesRequest extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
